<script>

    import { createEventDispatcher } from 'svelte';
    /**
     * @typedef {Object} Props
     * @property {any} action
     * @property {any} active
     * @property {any} icon
     * @property {any} label
     * @property {boolean} [confirm]
     * @property {string} [align]
     * @property {boolean} [noAriaRole]
     * @property {any} [role]
     * @property {string} [as]
     * @property {boolean} [asMenu]
     */
    let {
        action,
        active,
        icon,
        label,
        confirm = false,
        align = 'left',
        noAriaRole = false,
        role = null,
        as = 'li',
        asMenu = false
    } = $props();

    let showConfirm = $state(false);
    

    const dispatch = createEventDispatcher();
    let element = $state();

    function handleMenuItemClick(e) {
        e.stopImmediatePropagation();
        if (confirm) {
            showConfirm = true;

            setTimeout(() => {
                element.querySelector('button[aria-label="Yes"]').focus();
            });
        } else {
            dispatch('click', { action, label });
        }
    }

    function handleCancelClick(e) {
        e.stopImmediatePropagation();
        showConfirm = false;
    }
</script>

<svelte:element
    this={as}
    bind:this={element}
    class="floating-menu-row interactive {align} {active ? 'active' : ''}"
    role={noAriaRole ? null : role ?? 'menuitem'}
>
    {#if showConfirm}
        <div class="confirm">
            <span>Are you sure?</span>

            <button
                onclick={() => dispatch('click', action)}
                class="interactive"
                aria-label="Yes"
            >
                <i class="material-icons icon-button green">check_circle</i>
            </button>

            <button
                onclick={handleCancelClick}
                class="interactive"
                aria-label="No"
            >
                <i class="material-icons icon-button red">cancel</i>
            </button>
        </div>
    {:else}
        <button
            onclick={handleMenuItemClick}
            class="interactive"
            aria-label="{label} Options"
            {...asMenu || showConfirm === false
                ? null
                : { 'aria-expanded': showConfirm }}
        >
            {#if align === 'right'}
                <span>{label}</span>
            {/if}
            {#if icon}
                {#if icon && icon.indexOf('.') > -1}
                    <i
                        class="profile-icon"
                        style="background-image:url({icon});"
                    ></i>
                    {#if align === 'left'}
                        <span>{label}</span>
                    {/if}
                {:else if icon}
                    <i class="material-icons" aria-hidden="true">{icon}</i>
                    {#if align === 'left'}
                        <span>{label}</span>
                    {/if}
                {/if}
            {:else}
                <i class="icon-space"></i>
                {#if align === 'left'}
                    <span>{label}</span>
                {/if}
            {/if}
        </button>
    {/if}
</svelte:element>

<style>
    button {
        background: transparent;
    }

    .floating-menu-row {
        flex-shrink: 0;
        color: #eee;
    }

    .floating-menu-row button {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: flex-start;
        justify-items: center;
        padding-right: 1rem;
    }

    .floating-menu-row:hover {
        background-color: rgba(0, 0, 0, 0.3);
    }

    .floating-menu-row i {
        margin: 0.75rem;
        color: inherit;
    }

    .floating-menu-row button {
        color: inherit;
        width: 100%;
    }

    .floating-menu-row button span {
        text-transform: capitalize;
        flex-shrink: 0;
        margin: 0.25rem 1rem 0.25rem 0;
        line-height: 3rem;
    }

    .right {
        justify-content: space-between;
        padding-left: 1rem;
        padding-right: 0.25rem;
    }

    .right button {
        margin-right: 0rem;
    }

    .profile-icon {
        width: 2rem;
        height: 2rem;
        border: 1px solid rgba(255, 255, 255, 0.5);
        border-radius: 4rem;
        background-color: rgba(255, 255, 255, 0.5);
        background-position: center center;
        background-size: cover;
        background-repeat: no-repeat;
        margin: 0 0.5rem;
    }

    .confirm {
        display: flex;
        align-items: center;
        padding: 0.25rem 0.5rem 0.25rem 1rem;
    }

    .confirm > span {
        width: fit-content;
        white-space: nowrap;
    }

    .confirm i {
        margin: 0rem 0.25rem;
    }
    .icon-button {
        padding: 0.5rem;
        border-radius: 20rem;
    }

    .icon-button:hover {
        background-color: rgba(255, 255, 255, 0.1);
    }

    .confirm i.green {
        color: rgb(74, 255, 83);
    }

    .confirm i.red {
        color: crimson;
    }

    .active {
        background-color: rgb(74, 198, 255);
        color: rgb(53, 53, 53);
    }

    .active:hover {
        color: rgb(241, 241, 241);
    }
</style>
